import angular from 'angular';
import Viewcart from './view-cart/view-cart';
import OrderHistory from './order-history/order-history';

let componentModule = angular.module('app.components', [
  Viewcart.name,
  OrderHistory.name  
]);

export default componentModule;



// WEBPACK FOOTER //
// ./src/app/components/components.js